<template>
  <div class="view-container text-center">
    <h1>Pagina principale</h1>
    <h4>Accesso ai servizi del portale</h4>
    
    <b-alert v-if="isCafSession" show variant="info" class="my-2">
            Accesso come titolare tramite operatore CAF
    </b-alert>

    <b-alert
      v-if="dichiarazioniIsVisible && open"
      variant="warning"
      :show="true"
      class="my-4 text-left"
      dismissible
    >
      <template v-if="open === 1"><b>ATTENZIONE:</b> C'è <b>una</b> dichiarazione da confermare. Per visualizzare, confermare o modificare la dichiarazione, accedere alla funzione <b>Accertamento dati anagrafici, redditi e patrimonio</b> in basso.</template>
      <template v-else><b>ATTENZIONE:</b> Ci sono <b>{{ open }}</b> dichiarazioni da confermare. Per visualizzare, confermare o modificare le dichiarazioni, accedere alla funzione <b>Accertamento dati anagrafici, redditi e patrimonio</b> in basso.</template>
    </b-alert>

    <notification-modal ref="notificationModal" />

    <div class="px-2 row align-self-stretch">
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/dichiarazioni.jpg')"
        title='Accertamento dati anagrafici, redditi e patrimonio.'
        DISABLED-description="Accertamento dati anagrafici, redditi e patrimonio (momentaneamente non disponibile)"
        description=""
        :route="{name:'dichiarazioni'}"
        :enabled="dichiarazioniIsVisible"
        disabledText="Funzione disponibile tramite accesso con SPID"
      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/comunicazioni.jpg')"
        title="Comunicazioni da Roma Capitale"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Comunicazioni"
        :route="{name:'comunicazioni'}"
        disabledText="Funzione momentaneamente non disponibile"
        :enabled="!isImpersonating"
      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/stampa-bollettini.jpg')"
        title="Stampa bollettini"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Bollettini"
        :route="{name:'bollette'}"
        disabledText="Funzione momentaneamente non disponibile"
        :enabled="!isImpersonating"

      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/situazione-contabile.jpg')"
        title="Estratto conto"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Situazione contabile"
        :route="{name:'estratticonto'}"
        disabledText="Funzione momentaneamente non disponibile"
        :enabled="!isImpersonating"

      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/normative.jpg')"
        title="Normative e regolamenti"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Elenco normative"
        :route="{name:'normative'}"
        :enabled="!isImpersonating"
      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/nuova-istanza.jpg')"
        title="Istanze"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Accedi"
        :route="{name:'istanze'}"
        :enabled="istanzeIsVisible && !isImpersonating"
        :xxxenabled="false"
        disabledText="Funzione disponibile tramite accesso con SPID"
      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/storico-istanze.jpg')"
        title="Storico istanze"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Visualizza"
        route="'not-found'"
        :enabled="false"
      />
      <feature-card
        class="col-12 col-md-4 col-lg-3"
        :img="require('../assets/images/nuova-istanza.jpg')"
        title="Abilitazione incaricati"
        DISABLED-description="Breve descrizione..."
        description=""
        action="Accedi"
        :route="{name:'incarichi'}"
        :enabled="false"
        disabledText="Funzione disponibile tramite accesso con SPID"
      />
    </div>

  </div>
</template>

<script>
import FeatureCard from '@/components/FeatureCard'
import NotificationModal from '@/components/NotificationModal'

export default {
  name: 'Home',
  components: {
    FeatureCard,
    NotificationModal
  },
  data () {
    return {
      open: 0,
      // openMessages: 0,
      isNotifiche: false
    }
  },
  computed: {
    isImpersonating() {
      return this.$store.state.auth.user && 
             this.$store.state.auth.user.userInc && 
             this.$store.state.auth.user.isCafSession;
    },
    isCafSession() {
        return this.$store.state.auth.user && this.$store.state.auth.user.isCafSession;
    },
    isRUValida () {
      // Solo per test
      // return true
      // In produzione, da verificare la valorizzazione di "this.$store.state.auth.user.validita"
      return process.env.NODE_ENV.trim() === 'production' ? this.$store.state.auth.user.validita === 'V' : true
    },

    
    isAutenticazioneSpid () {
      // console.log('isAutenticated() this.$store.state.auth.user', this.$store.state.auth.user, (this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === this.$store.state.auth.autentication.strong))
      // console.log('isAutenticated() this.$store.state.auth.user.userInc', this.$store.state.auth.user.userInc, (this.$store.state.auth.user && (this.$store.state.auth.user.userInc && this.$store.state.auth.user.userInc.autenticazione === this.$store.state.auth.autentication.strong)))
      
      let isUser = this.$store.state.auth.hasOwnProperty('user')
      let isUserInc = this.$store.state.auth.user.hasOwnProperty('userInc')
      // if (isUser) isUser = this.$store.state.auth.user.autenticazione === 'spid'
      // if (isUserInc) isUserInc = this.$store.state.auth.user.userInc.autenticazione === 'spid'
      if (isUser) isUser = this.$store.state.auth.user.autenticazione === this.$store.state.auth.autentication.strong
      if (isUserInc) isUserInc = this.$store.state.auth.user.userInc.autenticazione === this.$store.state.auth.autentication.strong

      // console.log('isAutenticated() isUser', isUser, this.$store.state.auth.user)
      // console.log('isAutenticated() isUserInc', isUserInc, this.$store.state.auth.user.userInc)

      // return  (this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === 'spid') ||
      //         (this.$store.state.auth.user && (this.$store.state.auth.user.userInc && this.$store.state.auth.user.userInc.autenticazione === 'spid'))
      return (this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === this.$store.state.auth.autentication.strong) ||
        (this.$store.state.auth.user && (this.$store.state.auth.user.userInc && this.$store.state.auth.user.userInc.autenticazione === this.$store.state.auth.autentication.strong))
    },


    dichiarazioniIsVisible () {
      // console.log('NODE_ENV', process.env.NODE_ENV)
      let idEnv = this.$store.state.auth.user.mode ? this.$store.state.auth.user.mode : process.env.NODE_ENV.trim()
      // let idEnv = 'test'

      // GM 20211115 - momentaneamente sospeso accesso (richiesta Riciniello)
      let retValue = this.$store.state.auth.user && this.isAutenticazioneSpid && this.isRUValida
      // console.log('dichiarazioniIsVisible this.$store.state.auth.user', this.$store.state.auth.user)
      // console.log('dichiarazioniIsVisible this.isAutenticazioneSpid', this.isAutenticazioneSpid)
      // console.log('dichiarazioniIsVisible this.isRUValida', this.isRUValida)
      // console.log('dichiarazioniIsVisible idEnv ', idEnv)
      // console.log('dichiarazioniIsVisible process.env', process.env)
      // let retValue = false

      if (idEnv === 'test' || idEnv === 'development' || idEnv === 'dev') {
        retValue = true
      }

      return retValue

      // return this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === 'spid' && this.$store.state.auth.user.validita === 'V'
      // GM: SOLO TEST abilita accesso a parte sottoposta a SPID solo per test
      // console.log('Verifica visibilità DICH', this.$store.state.auth.user.validita )
      // return true
    },
    istanzeIsVisible () {
      // console.log('NODE_ENV', process.env.NODE_ENV, this.$store.state.auth.user)
      let idEnv = this.$store.state.auth.user.mode ? this.$store.state.auth.user.mode : process.env.NODE_ENV.trim()
      // let idEnv = 'test'
      // let retValue = this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === 'spid' && this.$store.state.auth.user.validita === 'V'
      let retValue = this.$store.state.auth.user && this.isAutenticazioneSpid && this.isRUValida // this.$store.state.auth.user.validita === 'V'

      // let retValue = this.$store.state.auth.user && this.$store.state.auth.user.validita === 'V'
      // console.log('istanzeIsVisible', retValue, this.$store.state.auth.user, this.$store.state.auth.user.validita)
      // let retValue = this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === 'spid' && this.$store.state.auth.user.validita === 'V'
      //     && (this.$store.state.auth.user.codiceFiscale === 'SNNFBA57E03H501C' ||
      //     this.$store.state.auth.user.codiceFiscale === '96392050587' ||
      //     this.$store.state.auth.user.codiceFiscale === 'SLAMNO76E57H501O')

      // let retValue = this.$store.state.auth.user && this.$store.state.auth.user.codiceFiscale === 'SLAMNO76E57H501O'
      // console.log('retValue in produzione', retValue)
      if (idEnv === 'test' || idEnv === 'development' || idEnv === 'dev') {
        retValue = true
      }

      return retValue

      // return this.$store.state.auth.user && this.$store.state.auth.user.autenticazione === 'spid' && this.$store.state.auth.user.validita === 'V'
      // GM: SOLO TEST abilita accesso a parte sottoposta a SPID solo per test
      // console.log('Verifica visibilità DICH', this.$store.state.auth.user.validita )
      // return true
    }

  },
  async created () {
    await this.load()
  },
  methods: {
    async load () {
      try {
        // console.log('Home User', this.$store.state.auth.user)
        // console.log('Home first logon', this.$store.state.auth.user.firstlogon)

        // GM: solo per testatre la "firstLogon"
        // this.$store.state.auth.user.firstlogon = true
        // if (this.$store.state.auth.user.firstlogon && this.$store.state.auth.user.autenticazione !== 'spid') {
        if (this.$store.state.auth.user.firstlogon && !this.isAutenticazioneSpid) {
          // Devo forzare la modifica della password
          this.$router.push({ name: 'changePassword' })
        }
        await this.$store.dispatch('dichiarazioni/countOpen')
        this.open = this.$store.state.dichiarazioni.open

        // Verifica presenza di notifiche per attivare la visualizzazione.
        let test = await this.badgeValue()
        this.isNotifiche = test > 0 ? true : false || false
        // console.log('viewNot ', this.isNotifiche, this.$store.state.messages)

        if (this.isNotifiche) {
          await this.$refs.notificationModal.open()
        }

        // console.log('this.dichiarazioniIsVisible', this.dichiarazioniIsVisible)
      } catch (err) {
        this.$ui.showError(err)
      }
    },
    async badgeValue () {
      let retValue
      try {
        await this.$store.dispatch('messages/countPrimaVisione')
        retValue = this.$store.state.messages.openPrima || 0
        await this.$store.dispatch('messages/countOpen')
        // this.openMessages = this.$store.state.messages.open
        // console.log('Cerca conteggio messages/countPrimaVisione', retValue, this.$store.state.messages)
      } catch (err) {
        this.$ui.showError(err)
      }
      return retValue
    }
  }
}
</script>
